// Packages Imports
import React from 'react';
import classNames from 'classnames';

// Style Imports
import styles from './loader.module.scss';

interface LoaderProps {
  message?: string;
  size?: 'tiny' | 'small' | 'medium' | 'large';
  variant?: '1' | '2' | '3';
}

const Loader: React.FC<LoaderProps> = ({ message, size = 'regular', variant = '1' }) => {
  const classes = [styles.loader];
  
  switch(size) { 
    case 'tiny': 
      classes.push(styles.tiny);
      break; 
    case 'small': 
      classes.push(styles.small);
      break; 
    case 'medium': 
      classes.push(styles.medium);
      break; 
    case 'large': 
      classes.push(styles.large);
      break; 
    default:
      classes.push(styles.regular);
      break; 
  } 
  
  const imageSrc = `/images/loader${variant}.svg`;

  return (
    <div className={classNames(classes)}>
      { }
      <img src={imageSrc} alt='' />
      {message && <p>{message}</p>}
    </div>
  ); 
};

export default Loader;
